module.exports = __webpack_public_path__ + "static/media/marcy-newdev.4e1f4a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marcy-newdev.png
// module id = 955
// module chunks = 0